import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";
import heroBackground from "@/assets/hero-background.jpg";
import WaitlistModal from "./WaitlistModal";
import { useWaitlist } from "@/hooks/useWaitlist";
const HeroSection = () => {
  const [waitlistModalOpen, setWaitlistModalOpen] = useState(false);
  const {
    waitlistCount
  } = useWaitlist();
  const scrollToFeatures = () => {
    const featuresSection = document.getElementById("features");
    if (featuresSection) {
      featuresSection.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${heroBackground})`
    }} />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center lg:text-left">
        <div className="max-w-4xl">
          <Badge className="mb-6 bg-primary/20 text-primary border-primary/30 hover:bg-primary/30">
            Coming Soon - Join the Waitlist
          </Badge>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Plan. Explore. Share.
            <span className="text-transparent bg-gradient-to-r from-primary-glow to-accent bg-clip-text animate-glow-pulse">
              {" "}Repeat.
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl leading-relaxed">
            The community platform for off-road adventurers. Research trails before you go, 
            track your adventures as you explore, share your stories with fellow enthusiasts, 
            and inspire others to get outdoors. Built by explorers who care about the trails we love.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button variant="hero" size="lg" className="text-lg px-8 py-6" onClick={() => setWaitlistModalOpen(true)}>
              Claim Your Spot
            </Button>
            <Button variant="adventure" size="lg" className="text-lg px-8 py-6" onClick={scrollToFeatures}>
              See What's Coming
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl">
            {waitlistCount ? <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4 border border-white/20">
                <div className="flex items-center justify-center gap-2 text-2xl font-bold text-primary-glow">
                  <Users className="w-5 h-5" />
                  {waitlistCount}+
                </div>
                <div className="text-white/80 text-sm">Adventurers Waiting</div>
              </div> : <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4 border border-white/20">
                <div className="text-2xl font-bold text-primary-glow">500+</div>
                <div className="text-white/80 text-sm">Trail Segments</div>
              </div>}
            <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4 border border-white/20">
              <div className="text-2xl font-bold text-primary-glow">SoCal</div>
              <div className="text-white/80 text-sm">Launch Region</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4 border border-white/20">
              <div className="text-2xl font-bold text-primary-glow">2026</div>
              <div className="text-white/80 text-sm">Early Access</div>
            </div>
          </div>

          {/* Soft urgency text */}
          <p className="mt-6 text-white/60 text-sm">
            Limited spots for early access. The waitlist may close as we approach launch.
          </p>
        </div>
      </div>
      
      {/* Animated Elements */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-float">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>

      {/* Waitlist Modal */}
      <WaitlistModal open={waitlistModalOpen} onOpenChange={setWaitlistModalOpen} />
    </section>;
};
export default HeroSection;